/*
 * Copyright (c) 2021 EGT Digital - All rights reserved.
 *
 * File: JackpotLevelValue.tsx
 *
 * Written by Yuliyan Milenkov <yuliyan.milenkov@egt-digital.com> on  03.10.22 3:24 pm.
 * Last modified: 03.10.22 3:24 pm.
 *
 * More information at: https://egt-digital.com/
 */
import React from 'react';
import { formatCurrencyValue } from '../api/helpers';
import { useSettings } from '../contexts/SettingsContext';

const JackpotLevelValue = ({ value, denomination, className }: IJackpotLevelValueProps) => {
    const [settings] = useSettings();
    const formattedValue = formatCurrencyValue(value * denomination, settings.units);

    return <span className={className}>{formattedValue}</span>;
};

interface IJackpotLevelValueProps {
    value: number;
    denomination: number;
    className?: string;
}

export default JackpotLevelValue;
